module.exports = __webpack_public_path__ + "img/epic.df049c32.png";